import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

const DeleteProperties: FunctionComponent<{ properties: any, onDeleteProperties: any }> = (props) => {


    const { t } = useTranslation();

    const DropProperties = () => {
        const listings = {
            "properties": props.properties,
        }
        console.log(listings)
        props.onDeleteProperties(listings)
    }


    return (<>

        <button type="submit" className={`button-dash border-trans color-FF002E back-FEF2F2 padd-15-30 padd-10-15-mb marg-right-16 mb-3 ${props.properties.length <= 1 ? "disabled" : ''}`} data-bs-toggle="modal"
            data-bs-target={`#delete-properties`}>
            {t('propertiesPage.delete')}
        </button>

        <div className="modal fade" id={"delete-properties"} aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="title-18"> {t('propertiesPage.confirmation')}</h5>
                    </div>
                    <div className="modal-body mb-3 mt-3">
                        <p className="para-16">{t('propertiesPage.msgConfirmation')}</p>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="button-dash btn-outline-secondary back-trans padd-15 padd-5-15-mb marg-right-16" data-bs-dismiss="modal">
                            {t('propertiesPage.no')}
                        </button>
                        <button type="button" data-bs-dismiss="modal" className="button-dash padd-15 padd-5-15-mb btn-danger" onClick={DropProperties}>
                            {t('propertiesPage.yes')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </>
    )
}
export default DeleteProperties;
